export const response = {
  places: [
    {
      formattedAddress: "206 Wisconsin Ave, Oceanside, CA 92054, USA",
      websiteUri: "http://the-cup-coffee.cafes-usa.com/",
      priceLevel: "PRICE_LEVEL_INEXPENSIVE",
      displayName: {
        text: "The Cup Coffee",
        languageCode: "en",
      },
    },
    {
      formattedAddress: "1700 Oceanside Blvd, Oceanside, CA 92054, USA",
      websiteUri:
        "https://locations.dutchbros.com/dutch-bros-coffee-002bdf0ea0f7?y_source=1_MzA1ODYxNTAtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      priceLevel: "PRICE_LEVEL_INEXPENSIVE",
      displayName: {
        text: "Dutch Bros Coffee",
        languageCode: "en",
      },
    },
    {
      formattedAddress: "1050 S Coast Hwy, Oceanside, CA 92054, USA",
      websiteUri: "https://betterbuzzcoffee.com/pages/oceanside-location",
      priceLevel: "PRICE_LEVEL_MODERATE",
      displayName: {
        text: "Better Buzz Coffee - Oceanside",
        languageCode: "en",
      },
    },
    {
      formattedAddress: "1918 Oceanside Blvd, Oceanside, CA 92054, USA",
      websiteUri: "https://br.coffee/",
      priceLevel: "PRICE_LEVEL_INEXPENSIVE",
      displayName: {
        text: "Black Rock Coffee Bar",
        languageCode: "en",
      },
    },
    {
      formattedAddress: "1880 Marron Rd #100, Carlsbad, CA 92008, USA",
      websiteUri:
        "https://www.clover.com/online-ordering/ding-tea-carlsbad-carlsbad?utm_source=web-dashboard&utm_medium=qrcode&utm_campaign=olo-qr-template",
      priceLevel: "PRICE_LEVEL_INEXPENSIVE",
      displayName: {
        text: "DING TEA CARLSBAD",
        languageCode: "en",
      },
    },
    {
      formattedAddress: "2263 S El Camino Real, Oceanside, CA 92054, USA",
      websiteUri: "https://www.starbucks.com/store-locator/store/1006757/",
      priceLevel: "PRICE_LEVEL_MODERATE",
      displayName: {
        text: "Starbucks",
        languageCode: "en",
      },
    },
    {
      formattedAddress: "300 Pier View Wy, Oceanside, CA 92054, USA",
      websiteUri: "https://www.pierviewcoffeeco.com/",
      priceLevel: "PRICE_LEVEL_INEXPENSIVE",
      displayName: {
        text: "Pier View Coffee Co",
        languageCode: "en",
      },
    },
    {
      formattedAddress: "2110 S Coast Hwy Suite C, Oceanside, CA 92054, USA",
      websiteUri: "http://www.boundbycoffee.net/",
      displayName: {
        text: "Bound Coffee Company",
        languageCode: "en",
      },
    },
    {
      formattedAddress: "602 Mission Ave, Oceanside, CA 92054, USA",
      websiteUri: "http://1022gelato.com/",
      displayName: {
        text: "1022 Cafe & Gelateria",
        languageCode: "en",
      },
    },
    {
      formattedAddress: "300 Carlsbad Village Dr #211, Carlsbad, CA 92008, USA",
      websiteUri: "http://vinakacafe.net/",
      priceLevel: "PRICE_LEVEL_INEXPENSIVE",
      displayName: {
        text: "Vinaka Cafe",
        languageCode: "en",
      },
    },
    {
      formattedAddress: "2405 Oceanside Blvd, Oceanside, CA 92054, USA",
      websiteUri: "https://www.comeonovercafe.com/",
      priceLevel: "PRICE_LEVEL_INEXPENSIVE",
      displayName: {
        text: "Come On Over Cafe",
        languageCode: "en",
      },
    },
    {
      formattedAddress:
        "Oceanside Crossing, 1779 S Oceanside Blvd, Oceanside, CA 92054, USA",
      websiteUri: "https://www.starbucks.com/store-locator/store/17716/",
      priceLevel: "PRICE_LEVEL_MODERATE",
      displayName: {
        text: "Starbucks",
        languageCode: "en",
      },
    },
    {
      formattedAddress: "2158 Vista Way, Oceanside, CA 92054, USA",
      websiteUri: "https://www.starbucks.com/store-locator/store/16266/",
      priceLevel: "PRICE_LEVEL_MODERATE",
      displayName: {
        text: "Starbucks",
        languageCode: "en",
      },
    },
    {
      formattedAddress: "1836 S Coast Hwy, Oceanside, CA 92054, USA",
      websiteUri: "http://www.revoroasters.com/",
      priceLevel: "PRICE_LEVEL_INEXPENSIVE",
      displayName: {
        text: "Revolution Roasters",
        languageCode: "en",
      },
    },
    {
      formattedAddress: "1575 S Coast Hwy, Oceanside, CA 92054, USA",
      websiteUri: "https://www.vigilantecoffee.com/",
      priceLevel: "PRICE_LEVEL_MODERATE",
      displayName: {
        text: "Vigilante Coffee",
        languageCode: "en",
      },
    },
    {
      formattedAddress: "129 S Coast Hwy, Oceanside, CA 92054, USA",
      websiteUri: "https://www.northcountyroastery.com/",
      displayName: {
        text: "North County Roastery",
        languageCode: "en",
      },
    },
    {
      formattedAddress: "1702 Mission Ave, Oceanside, CA 92058, USA",
      websiteUri: "https://www.starbucks.com/store-locator/store/1009064",
      priceLevel: "PRICE_LEVEL_MODERATE",
      displayName: {
        text: "Starbucks",
        languageCode: "en",
      },
    },
    {
      formattedAddress: "3016 Carlsbad Blvd, Carlsbad, CA 92008, USA",
      websiteUri: "http://www.betterbuzzcoffee.com/",
      priceLevel: "PRICE_LEVEL_MODERATE",
      displayName: {
        text: "Better Buzz Coffee Carlsbad",
        languageCode: "en",
      },
    },
    {
      formattedAddress: "2588 El Camino Real Suite H, Carlsbad, CA 92008, USA",
      websiteUri: "https://www.parisbaguette.com/",
      displayName: {
        text: "Paris Baguette",
        languageCode: "en",
      },
    },
    {
      formattedAddress: "101 N Cleveland St, Oceanside, CA 92054, USA",
      websiteUri: "https://campcoffeeco.square.site/",
      displayName: {
        text: "Camp Coffee Company",
        languageCode: "en",
      },
    },
  ],
};
